import * as api from '../api';


export function downloadImage(id) {
  return api.get(`upload/download/${id}`);
}
